import { FC, useState } from "react"
import { Button } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { format } from "date-fns"
import { es } from "date-fns/locale"
import { MonthMenu } from "./MonthMenu"

interface MonthPickerButtonProps {
    selectedDate: Date
    setSelectedDate: React.Dispatch<React.SetStateAction<Date>>
    disabled?: boolean
}

export const MonthPickerButton: FC<MonthPickerButtonProps> = ({
    selectedDate,
    setSelectedDate,
    disabled
}: MonthPickerButtonProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

    const toggleMonthPicker = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleMonthSelect = (
        year: number,
        monthIndex: number,
        closeMenu = true
    ) => {
        const newDate = new Date(year, monthIndex, selectedDate.getDate())
        if (newDate.getMonth() !== monthIndex) newDate.setDate(0)
        setSelectedDate(newDate)
        if (closeMenu) setAnchorEl(null)
    }

    const isMonthDisabled = (year: number, monthIndex: number) => {
        const now = new Date()
        const currentMonthIndex = now.getMonth()
        const currentYear = now.getFullYear()

        const monthsFromNow = (year - currentYear) * 12 + monthIndex - currentMonthIndex

        return monthsFromNow < -12 || monthsFromNow > 12
    }

    return (
        <>
            <Button
                onClick={toggleMonthPicker}
                variant="text"
                sx={{
                    fontSize: "0.75rem",
                    fontWeight: "medium",
                    textTransform: "none",
                    color: "#fff",
                    px: 2,
                    py: 1.35,
                    borderRadius: 3,
                    background: "#212D39",
                    '&:hover': {
                        background: '#212D39',
                        color: '#fff',
                    },
                    '&.Mui-disabled': {
                        backgroundColor: '#4a5568',
                        color: '#cfd8dc',
                        cursor: 'not-allowed',
                    },
                }}
                endIcon={<ExpandMoreIcon sx={{ color: disabled ? '#cfd8dc' : '#fff' }} />}
                disabled={disabled}
            >
                {format(selectedDate, "MMMM yyyy", { locale: es }).replace(/^./, (c) => c.toUpperCase())}
            </Button>

            <MonthMenu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                selectedDate={selectedDate}
                handleMonthSelect={handleMonthSelect}
                isMonthDisabled={isMonthDisabled}
            />
        </>
    )
}